import { NotificationPreference } from '../models/Notification';
import { NotificationRepository } from '../repositories/NotificationRepository';
import { logger } from '@/src/core/utils';

export class GetNotificationPreferencesUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(userId: string): Promise<NotificationPreference[]> {
    logger.debug('GetNotificationPreferences', 'Fetching preferences', { userId });
    return await this.notificationRepository.getPreferences(userId);
  }
}
